import { render, staticRenderFns } from "./ByUpload.vue?vue&type=template&id=10f739b8&scoped=true"
import script from "./ByUpload.vue?vue&type=script&lang=js"
export * from "./ByUpload.vue?vue&type=script&lang=js"
import style0 from "./ByUpload.vue?vue&type=style&index=0&id=10f739b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f739b8",
  null
  
)

export default component.exports